import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsLayout, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { BaseDropout, StaffPermissions, TrimesterAccMentorWithAccDetails } from '@interfaces';
import { AppService, DomainDataService } from '../../../../services';
import { getSetup } from './grid/get-setup';

export interface MentorDropoutsGridServiceInterface {
	layout: Signal<PageTabsLayout | undefined>,
	areaService: {
		reloadData: () => Promise<void>,
		selectedTrimesterName: Signal<string | undefined>,
		staffPermissions: Signal<StaffPermissions>
	}
}

export interface AccMentorDropout extends BaseDropout {
	accMentorId: number,
	accTeamId: number,
	volunteerId: number,
	personId: number,
	name: string,
	accId: number,
	accName: string,
	facilitatorName: string,
	dropoutReason: string,
}


@Component({
	selector: 'mentor-dropouts-grid-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './mentor-dropouts-grid.part.html',
})
export class MentorDropoutsGridPart {

	public parent = input.required<string>();
	public rows = input.required<TrimesterAccMentorWithAccDetails[]>();
	public service = input.required<MentorDropoutsGridServiceInterface>();

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly dialogService = inject(DialogService);
	private readonly domain = inject(DomainDataService);

	public setup = computed(() => getSetup(this.parent(), this.util, this.dialogService, this.service()));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		const layout = this.service().layout();
		if (layout) {
			return { layout: layout, viewSelector: true };
		}
		return undefined;
	});

	public mentorDropouts = computed<AccMentorDropout[]>(() => {

		return this.rows().map(v => {
			return {
				...v.dropout!, //always defined because of the filter above
				dropoutReason: this.domain.data().dropoutReasonsMap[v.dropout!.dropoutReasonId]?.name ?? '',
				accMentorId: v.accMentorId,
				name: v.name,
				accTeamId: v.accTeamId,
				volunteerId: v.volunteerId,
				personId: v.personId,
				accId: v.accId,
				accName: v.accName,
				facilitatorName: this.app.getStaffNameById(v.facilitatorStaffId) ?? '',
			};
		});
	});
}